import React, { FC, useState, useEffect, PropsWithChildren, createContext, memo } from 'react';
import classNames from 'classnames';
import View from '../view';

interface IRadioGroupProps {
  className?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

interface IToggleOptionProps {
  value: string;
}

interface IRadioGroupContext {
  value?: string;
  disabled?: boolean;
  toggleOption: (option: IToggleOptionProps) => void;
}

export const GroupContext = createContext<IRadioGroupContext | null>(null);

const RadioGroup: FC<PropsWithChildren<IRadioGroupProps>> = memo(({ children, className = '', value: propsValue, defaultValue, disabled, onChange }) => {
  const [value, setValue] = useState<string | undefined>(propsValue || defaultValue);

  const rootCls = classNames('ink-radio-group', className);

  const context = {
    toggleOption: (toggledOpt: IToggleOptionProps) => {
      const newValue = toggledOpt?.value;
      /**
       * props.value 传入，为受控组件，通过 onChange 事件来更新 selectedList
       * props.value 未传入，未非受控组件，使用内部状态更新，但仍调用 onChange 回调
       */
      if (typeof propsValue === 'undefined') {
        setValue(newValue);
      }

      if (onChange && typeof onChange === 'function') {
        onChange(newValue);
      }
    },
    value,
    disabled,
  };

  useEffect(() => {
    if (propsValue) {
      setValue(propsValue);
    }
  }, [propsValue]);

  return (
    <View className={rootCls}>
      <GroupContext.Provider value={context}>{children}</GroupContext.Provider>
    </View>
  );
});

export default RadioGroup;
